import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { get, isNil } from 'lodash';
import HouseholdCountDisplay from './HouseholdCountDisplay';
import HouseholdCountForm from './HouseholdMembersForms/components/HouseholdCountForm';
import RowDisplay from '../../common/RowDisplay';
import Spinner from '../../common/spinners/Spinner';
import EditModal from '../../common/modal/EditModal';
import UnknownHouseholdCount from './UnknownHouseholdCount';
import './HouseholdMembers.scss';
var DEFAULT_HOUESHOLD_COUNT = {
  total: '',
  adults: '',
  children: ''
};
export var HouseholdMembers = /*#__PURE__*/function (_Component) {
  _inherits(HouseholdMembers, _Component);
  var _super = _createSuper(HouseholdMembers);
  function HouseholdMembers(props) {
    var _this;
    _classCallCheck(this, HouseholdMembers);
    _this = _super.call(this, props);
    _this.state = {
      loading: false
    };
    _this.displayMemberData = _this.displayMemberData.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(HouseholdMembers, [{
    key: "displayMemberData",
    value: function displayMemberData(householdSize, editHouseholdCount, householdCount) {
      var loading = this.state.loading;
      if (loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          scale: 0.5
        });
      }
      return /*#__PURE__*/React.createElement(RowDisplay, {
        label: "Household Size ".concat(householdSize ? "(".concat(householdSize, ")") : ''),
        editSection: editHouseholdCount
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement(HouseholdCountDisplay, {
        label: "Adults",
        value: householdCount.adults
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement(HouseholdCountDisplay, {
        label: "Children",
        value: householdCount.children
      })), /*#__PURE__*/React.createElement(UnknownHouseholdCount, {
        householdCount: householdCount
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        contact = _this$props.contact,
        groupId = _this$props.groupId;
      var householdSize = get(contact, 'household.total', 0);
      var householdCount = isNil(contact.household) ? DEFAULT_HOUESHOLD_COUNT : contact.household;
      var editHouseholdCount = /*#__PURE__*/React.createElement(EditModal, {
        header: "Edit Household",
        size: "normal",
        formName: "household-count-form",
        editButtonId: "edit-household-count-btn",
        id: "edit-household-count-modal"
      }, /*#__PURE__*/React.createElement(HouseholdCountForm, {
        householdCount: householdCount,
        closeModal: this.closeModal,
        contact: contact
      }));
      return /*#__PURE__*/React.createElement("div", {
        className: "household-members"
      }, this.displayMemberData(householdSize, editHouseholdCount, householdCount));
    }
  }]);
  return HouseholdMembers;
}(Component);
HouseholdMembers.propTypes = {
  contact: PropTypes.object.isRequired
};
export default HouseholdMembers;
//# sourceMappingURL=HouseholdMembers.js.map